import { Directive, HostBinding } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

@Directive({
  selector: '[evkMatHeadLine]'
})
export class MatHeadLineDirective {

    @HostBinding('class')
    public class = 'mat-headline align-middle';

    @HostBinding('style')
    public get style(): SafeStyle {
        return this.sanitizer.bypassSecurityTrustStyle('display: flex; align-items: center');
    }

    constructor(private sanitizer: DomSanitizer) {}

}
